export default __webpack_public_path__ + "static/media/instruction-title-2.2fd1d471.png";